import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { OptionFilter } from '@periscopes/general/filters';
import { useSalesforceUsers } from '@hooks';

import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';

export const SalesforceUserFilter: FilterComponent<Array<string>> = (props) => {
	const { format, id, label, onChange, value } = props;

	const users = useSalesforceUsers();

	const options = useMemo(() => {
		const userMap = users?.map((user) => ({
			label: user.name,
			value: user.username
		}));

		userMap?.unshift({
			label: COPY_SPECIFIC.NO_LABELED(label),
			value: 'null'
		});

		return userMap ?? [];
	}, [ label, users ]);

	return (
		<FilterComponent
			{ ...props }
			tagProps={ {
				value: options
					.filter((option) => value?.includes(option.value))
					.map((option) => option.label)
					.join(', ')
			} }>
			<OptionFilter
				className='filter'
				getPopupContainer={ getDirectParent }
				id={ getFilterId(id) }
				loading={ !options }
				maxTagCount='responsive'
				mode='multiple'
				onChange={ (usernames: Array<string>) => {
					onChange({
						[ id ]: {
							format,
							value: usernames
						}
					});
				} }
				options={ options ?? [] }
				placeholder={ PLACEHOLDERS_COPY.FILTER_BY(label) }
				showArrow
				value={ value } />
		</FilterComponent>
	);
};
